<div
  class="offcanvas offcanvas-bottom switch-box-offcanvas"
  tabindex="-1"
  id="switchBoxAction"
  aria-labelledby="offcanvasBottomLabel"
>
  <div class="offcanvas-header p-0">
    <h5 class="offcanvas-title lg-header-text" id="offcanvasBottomLabel">{{ header }}</h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
<div class="offcanvas-body p-0 small">
  <label class="option mt-2" *ngFor="let box of dispatchBoxes">
    <input
      type="radio"
      name="package"
      [value]="box"
      [(ngModel)]="selectedDispatchBoxes"      
    >
    <div class="option-content" [class.selected]="selectedDispatchBoxes.id === box.id">
      <div class="option-title">{{ box.shipmentBox.name }}</div>
      <div class="option-desc">{{ box.name }}</div>
    </div>
  </label>
</div>

  <div class="offcanvas-bottom small">
    <button
      class="black-btn custom-btn w-100" 
      [ngClass]="false ? 'btn-disabled' : 'btn-enabled'"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="onSelectBox(this.selectedDispatchBoxes)"
    >
      Confirm
    </button>
</div>

</div>